export const cardLink =
  'https://cards.kapitalbank.az/az/BRCB_BLACK/bb/?utm_medium=button&utm_source=tap.az&utm_campaign=0-CNV-birbank-cards-AZ&utm_content=cards-page';

export const creditLink =
  'https://ccl.kapitalbank.az/az/order/GTKR?t=bb&utm_medium=button&utm_source=tap.az&utm_campaign=0-CNV-nagd-kredit-AZ&utm_content=product-page';
